const strings = {
  NAME: 'Namn',
  OUT_OF_ORDER: 'Ur funktion',
  CANCEL: 'Avbryt',
  DONE: 'Klar'
}

export default strings



// WEBPACK FOOTER //
// ./src/components/common/LaundryModal/strings.js